class ProductMediaSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    let splide = new Splide(".component--product--media__slider", {
      perPage: 1,
      pagination: false,
      arrows: true,
      padding: { left: 0, right: 0 },
      gap: "2.25rem",
      breakpoints: {
        768: {
          padding: { left: "24px", right: "15%" },
          gap: "0.5rem",
        },
      },
    });
    let thumbnails = document.getElementsByClassName(
      "component--product--media__thumbnail"
    );
    let current;
    for (let i = 0; i < thumbnails.length; i++) {
      initThumbnail(thumbnails[i], i);
    }
    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener("click", function () {
        splide.go(index);
      });
    }
    splide.on("mounted move", function () {
      let thumbnail = thumbnails[splide.index];
      if (thumbnail) {
        if (current) {
          current.classList.remove("is-active");
        }
        thumbnail.classList.add("is-active");
        current = thumbnail;
      }
    });
    splide.mount();
  }
}
customElements.define("product-media-slider", ProductMediaSlider);
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer");
    this.subscriptionSelector = document.querySelector("subscription-selector");
    this.productFormBar = document.querySelector("product-form-bar");
    this.addEventListener("change", this.onVariantChange);
    const seeMore = document.querySelector("[data-see-more]");
    if (seeMore) {
      this.seeMore = false;
      seeMore.addEventListener("click", this.toggleBox.bind(this, seeMore));
      this.bindSelector();
    }
  }
  // updateSavingPrice() {
  //   function removeCents(price) {
  //     price = price.replace("$", "").replace(/,/g, "");
  //     price = parseFloat(price);
  //     let roundedPrice = Math.floor(price);
  //     return `$${roundedPrice.toLocaleString()}`;
  //   }
  //   if (document.querySelectorAll("[data-discount-amount]").length > 0) {
  //     document.querySelectorAll("[data-discount-amount]").forEach((el) => {
  //       const price = el.getAttribute("data-discount-amount");
  //       const formattedprice = removeCents(price);
  //       el.innerHTML = `Save ${formattedprice}`;
  //     });
  //   }
  // }
  onVariantChange(e) {
    this.updateOptions();
    console.log('checking varaint',this.options);
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    //console.log(this.options);
    // if current variant is not available with options selected then remove last selected option.
    const changedOptionName = e.target.getAttribute("data-option-name");
    //console.log(changedOptionName);
    if (!this.currentVariant) {
      this.options.pop();
      this.currentVariants = this.getVariantData().filter((variant) => {
        return this.options.every((option, index) => {
          return variant.options[index] === option;
        });
      });
      this.currentVariant = this.currentVariants[0];
    }
    if (this.options.length > 1) {
      if (changedOptionName != "case") {
        this.options.pop();
        this.currentVariants = this.getVariantData().filter((variant) => {
          return this.options.every((option, index) => {
            return variant.options[index] === option;
          });
        });
        this.currentVariant = this.currentVariants[0];
      }
    }
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMediaByVariant();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.bindSelector();
    }

  
  }
  toggleBox(seeMore) {
    const box = document.querySelector(
      ".component--product--case-selector__options-box"
    );
    const labels = box.querySelectorAll("label");
    box.classList.toggle(
      "component--product--case-selector__options-box--hidden"
    );
    document
      .querySelector(".component--product--case-selector__see-more")
      .classList.toggle("component--product--case-selector__see-more--active");
    if (
      box.classList.contains(
        "component--product--case-selector__options-box--hidden"
      )
    ) {
      box.style.height =
        labels[0].clientHeight +
        labels[1].clientHeight +
        labels[2].clientHeight +
        "px";
      document
        .querySelector(".page--product--product__container")
        .setAttribute("data-see-more-clicked", "false");
    } else {
      box.style.height = box.scrollHeight + "px";
      seeMore.style.display = "none";
      const bulkBorderTop = document.querySelector(
        ".component--product--case-selector__bulk--border-top"
      );
      if (bulkBorderTop) {
        bulkBorderTop.style.opacity = "0.5";
      }
      document
        .querySelector(".page--product--product__container")
        .setAttribute("data-see-more-clicked", "true");
    }
  }
  bindSelector() {
    const box = document.querySelector(
      ".component--product--case-selector__options-box"
    );
    const radios = box.querySelectorAll('input[type="radio"]');
    const seeMore = document.querySelector("[data-see-more]");
    let isChecked = false;
    if (radios.length > 3) {
      for (let i = 3; i < radios.length; i++) {
        if (radios[i].checked) {
          isChecked = true;
          break;
        }
      }
      const isOpen = JSON.parse(
        document
          .querySelector(".page--product--product__container")
          .getAttribute("data-see-more-clicked")
      );
      if (isOpen) {
        box.classList.remove(
          "component--product--case-selector__options-box--hidden"
        );
        box.style.height = "auto";
        seeMore.style.display = "none";
        const bulkBorderTop = document.querySelector(
          ".component--product--case-selector__bulk--border-top"
        );
        if (bulkBorderTop) {
          bulkBorderTop.style.opacity = "0.5";
        }
      } else {
        if (isChecked) {
          document
            .querySelector(".page--product--product__container")
            .setAttribute("data-see-more-clicked", "true");
          box.classList.remove(
            "component--product--case-selector__options-box--hidden"
          );
          box.style.height = "auto";
          seeMore.style.display = "none";
          const bulkBorderTop = document.querySelector(
            ".component--product--case-selector__bulk--border-top"
          );
          if (bulkBorderTop) {
            bulkBorderTop.style.opacity = "0.5";
          }
        } else {
          const labels = box.querySelectorAll("label");
          if (labels.length > 3) {
            box.style.height =
              labels[0].clientHeight +
              labels[1].clientHeight +
              labels[2].clientHeight +
              "px";
          }
        }
      }
      // this.updateSavingPrice();
      /*if (isChecked) {
        box.classList.remove(
          "component--product--case-selector__options-box--hidden"
        );
        box.style.height = "auto";
        seeMore.style.display = "none";
        document.querySelector(
          ".component--product--case-selector__bulk--border-top"
        ).style.opacity = "0.5";
      } else {
        if (
          box.classList.contains(
            "component--product--case-selector__options-box--hidden"
          )
        ) {
          const labels = box.querySelectorAll("label");
          if (labels.length > 5) {
            box.style.height =
              labels[0].clientHeight +
              labels[1].clientHeight +
              labels[2].clientHeight +
              labels[3].clientHeight +
              labels[4].clientHeight +
              "px";
            seeMore.querySelector(
              ".component--product--case-selector__see-more-title"
            ).textContent = "See more quantities";
          }
        } else {
          box.style.height = box.scrollHeight + "px";
          seeMore.querySelector(
            ".component--product--case-selector__see-more-title"
          ).textContent = "See less quantities";
          seeMore.style.display = "none";
          document.querySelector(
            ".component--product--case-selector__bulk--border-top"
          ).style.opacity = "0.5";
        }
      }*/
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateMediaByVariant() {
    const variantMedia = document.querySelectorAll("[data-variants]");
    variantMedia.forEach((item) => {
      const value = item.getAttribute("data-variants");
      this.currentVariant.options.forEach((i) => {
        if (i == value) {
          item.classList.add("component--product--media__grid-item--active");
        } else {
          if (value != "") {
            item.classList.remove(
              "component--product--media__grid-item--active"
            );
          } else {
            item.classList.add("component--product--media__grid-item--active");
          }
        }
      });
    });
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }
  updateURL() {
    if (!this.currentVariant) return;
    function getUrlParameter(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    const queryDiscountCode = getUrlParameter("discount");
    if (queryDiscountCode) {
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}&discount=${queryDiscountCode}`
      );
    } else {
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const mediaSource = html.getElementById(
          "page--product--product__content"
        );
        const mediaD = document.getElementById(
          "page--product--product__content"
        );
        mediaD.innerHTML = mediaSource.innerHTML;
        const productStickyBar = document.querySelector("product-sticky-bar");
        if (productStickyBar) productStickyBar.toggle();


    var checkedRadio = $('.component--product--case-selector__options-box input[type="radio"]:checked');
    var checkedLabelQty = checkedRadio.next('label');
    var checkedQuantity = checkedLabelQty.data('case-index'); // Use .data() to get data-case-index attribute
    window.number = checkedQuantity;

           // Find the price inside the label
    var price = checkedLabelQty.find('.component--product--case-selector__label-item__price').text();
    console.log("Price:", price);

    // Append this price to .component--product--price__sale
    $('.component--product--price__sale').text(price);

              var discount = checkedLabelQty.find('.component--product--case-selector__label-item__discount').text();
    console.log("Discount:", discount);

    // Append this discount to .component--product--price__discount
    $('.component--product--price__discount').text(discount);

      });

  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      //const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute("disabled", true);
        if (text) addButton.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        let price;
        if (document.querySelector("[data-product-discount-price]")) {
          if (this.cart.cartDiscountCode) {
            price = document
              .querySelector("[data-product-discount-price]")
              .getAttribute("data-product-discount-price");
          } else if (
            this.cart.cookieDiscountCode === this.cart.cartDiscountCode ||
            this.cart.queryDiscountCode === this.cart.cartDiscountCode
          ) {
            price = document
              .querySelector("[data-product-discount-price]")
              .getAttribute("data-product-discount-price");
          }
        } else {
          price = this.currentVariant.price;
        }
        //console.log('fire', price)
        this.upsell = document.querySelector("product-upsell");
        if (document.querySelector("product-upsell")) {
          const upsellTotal = document
            .querySelector("[data-upsell-total]")
            .getAttribute("data-upsell-total");
          const productPriceElements = document.querySelectorAll(
            "[data-product-form-price]"
          );
          productPriceElements.forEach((productPriceElement) => {
            productPriceElement.setAttribute("data-product-form-price", price);
          });
          const total = JSON.parse(price) + JSON.parse(upsellTotal);
          addButton.textContent =
            window.variantStrings.addToCart + " — " + formatMoney(total);
        } else {
          addButton.textContent =
            window.variantStrings.addToCart + " — " + formatMoney(price);
        }
      }
      if (!modifyClass) return;
    });
  }
  setUnavailable() {
    //const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.unavailable;
      document
        .getElementById(`price-${this.dataset.section}`)
        ?.classList.add("visibility-hidden");
    });
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("variant-radios", VariantRadios);
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
  }

  attachProducts() {
    this.items = [];
    this.upsellElements = document.querySelectorAll(".component--product--upsell-main.selected");

    // Add selected upsell products
    this.upsellElements.forEach((upsell) => {
      const addOnId = upsell.getAttribute("data-add-on-id");
      if (addOnId) {
        this.items.push({
          id: parseInt(addOnId, 10),
          quantity: parseInt(upsell.getAttribute("data-add-on-qty") || "1", 10),
        });
      }
    });

    // Add main product
    const formData = JSON.parse(serializeForm(this.form));
    let item = null;
    if (formData.selling_plan == undefined) {
      item = {
        id: formData.id,
        quantity: formData.quantity,
      };
    } else {
      item = {
        id: formData.id,
        quantity: number,
        selling_plan: formData.selling_plan,
      };
    }
    this.items.push(item);
  }

async onSubmitHandler(evt) {
  console.log("clicked_submit");
  evt.preventDefault();

  const submitButton = this.querySelector('[type="submit"]');
  submitButton.classList.add("adding_product");
  submitButton.setAttribute("disabled", true);

  this.attachProducts();
  const newItems = this.items;
  fetch("/cart.js", { method: "GET" })
    .then((response) => response.json())
    .then((cart) => {
      const updatedItems = [];

      newItems.forEach((newItem) => {
        const existingItem = cart.items.find(
          (item) =>
            item.variant_id === newItem.id &&
            (!item.selling_plan || item.selling_plan === newItem.selling_plan)
        );

        if (existingItem) {
          updatedItems.push({
            id: existingItem.id,
            quantity: newItem.quantity,
          });
        } else {
          updatedItems.push({
            id: newItem.id,
            quantity: newItem.quantity,
            selling_plan: newItem.selling_plan || null,
          });
        }
      });
      const body = JSON.stringify({
        updates: updatedItems.reduce((acc, item) => {
          acc[item.id] = item.quantity;
          return acc;
        }, {}),
      });

      return fetch("/cart/update.js", { ...fetchConfig("javascript"), body });
    })
    .then((response) => response.json())
    .then((data) => {
      submitButton.classList.remove("adding_product");
      return fetch("/?section_id=global--cart-drawer")
        .then((response) => response.text())
        .then((state) => {
          this.cart.renderContents(state);
        });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.removeAttribute("disabled");
    });
}
}
customElements.define("product-form", ProductForm);
class ProductUpsellAddOn extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector("cart-drawer");

    this.addEventListener("click", (event) => {
      const button = event.target.closest('.component--product--upsell-add');
      button.classList.add("adding_product");
      if (button) {
        this.onAddToCartClick(event, button);
      }
    });
  }

  onAddToCartClick(event, button) {
    const upsellMarkup = event.target.closest('.component--product--upsell');
    const addOnId = upsellMarkup.getAttribute('data-add-on-id');
    const newQuantity = parseInt(upsellMarkup.getAttribute('data-add-on-qty'), 10) || 1;

    const submitButton = event.target;
    submitButton.setAttribute("disabled", true);

    fetch("/cart.js", { method: "GET" })
        .then(response => response.json())
        .then(cart => {
            const updatedItems = [];
            const existingItem = cart.items.find(item => item.variant_id == addOnId);

            if (existingItem) {
                // If variant exists in the cart, update its quantity (overwrite with new value)
                updatedItems.push({ id: existingItem.id, quantity: newQuantity });
            } else {
                // If not in cart, add as a new item
                updatedItems.push({ id: addOnId, quantity: newQuantity });
            }

            const body = JSON.stringify({
                updates: updatedItems.reduce((acc, item) => {
                    acc[item.id] = item.quantity;
                    return acc;
                }, {}),
            });

            return fetch("/cart/update.js", { ...fetchConfig("javascript"), body });
        })
        .then(response => {
          button.classList.remove("adding_product");
            if (!response.ok) throw new Error("Failed to update cart");
            return fetch(`/?section_id=global--cart-drawer`);
        })
        .then(response => response.text())
        .then(state => {
            this.cart.renderContents(state);
        })
        .catch(error => {
            console.error("Error updating cart:", error);
        })
        .finally(() => {
            submitButton.removeAttribute("disabled");
        });
}

}
customElements.define("product-upsell-add-on", ProductUpsellAddOn);
class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.buybox = document.querySelector(".component--product-form");
    this.bar = this.querySelector(".component--product--sticky-bar");
    this.footer = document.querySelector(".global--footer");
    this.productForm = document.querySelector("product-form");
    this.cart = document.querySelector("cart-drawer");
    this.bindEvents();
    this.toggle.bind(this);
  }
  bindEvents() {
    document.addEventListener("scroll", this.toggle.bind(this));
    document
  .querySelector(".component--product--sticky-bar__button")
  .addEventListener("click", (event) => {
    const button = event.target;
console.log('clicked_sticky');
    // Add the class to indicate the action is in progress

    // Call the handler and ensure the class is removed after completion
    this.onSubmitHandler(event, button);
  });
  }
  onSubmitHandler(event, button) {
    const submitButton = this.productForm.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);
    const form = this.productForm.querySelector("form");
    form.dispatchEvent(new Event("submit"));
  }
  toggle() {
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    let isVisible;
    if (mediaQuery.matches) {
      isVisible = this.checkVisibilityOfElements([
        "product-media-slider",
        "product-form",
      ]);
    } else {
      isVisible = this.checkVisibilityOfElements([
        "product-media-slider",
        "product-form",
      ]);
    }
    if (isVisible) {
      document
        .querySelector(".component--product--sticky-bar")
        .classList.remove("component--product--sticky-bar--active");
      this.footer.removeAttribute("style");
    } else {
      document
        .querySelector(".component--product--sticky-bar")
        .classList.add("component--product--sticky-bar--active");
      this.footer.style.marginBottom = this.offsetHeight + "px";
    }
  }
  checkVisibilityOfElements(elementIds) {
    return elementIds.some((elementId) => {
      const element = document.querySelector(elementId);
      const rect = element.getBoundingClientRect();
      // Returns true if the element is partially or fully within the viewport
      return rect.top < window.innerHeight && rect.bottom > 0;
    });
  }
}
customElements.define("product-sticky-bar", ProductStickyBar);
class ProductFAQ extends HTMLElement {
  constructor() {
    super();
    this.accordions = document.querySelectorAll(
      ".component--product--faq--question"
    );
    this.bindEvents();
  }
  bindEvents() {
    this.accordions.forEach((accordion) =>
      accordion.addEventListener("click", this.toggleAccordion.bind(this))
    );
  }
  toggleAccordion(event) {
    const element = event.currentTarget;
    element.classList.toggle("component--product--faq--question--active");
    this.accordions.forEach((accordion) => {
      if (accordion !== element) {
        accordion.classList.remove("component--product--faq--question--active");
      }
    });
  }
}
customElements.define("product-faq", ProductFAQ);
// Product Dropdown
class ProductDropdown extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector(
      ".component--product--dropdown__titles"
    );
    this.bindEvents();
  }
  bindEvents() {
    this.accordion.addEventListener("click", this.toggleAccordion.bind(this));
  }
  toggleAccordion(event) {
    const element = event.currentTarget;
    element.classList.toggle("component--product--dropdown__titles--active");
  }
}
customElements.define("product-dropdown", ProductDropdown);
class PublicationSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    let splide = new Splide(".page--product--publications__slider", {
      pagination: false,
      arrows: false,
      autoplay: true,
      breakpoints: {
        768: {
          pagination: true,
        },
      },
    });
    let thumbnails = document.getElementsByClassName(
      "page--product--publications__thumbnail"
    );
    let current;
    for (let i = 0; i < thumbnails.length; i++) {
      initThumbnail(thumbnails[i], i);
    }
    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener("click", function () {
        splide.go(index);
      });
    }
    splide.on("mounted move", function () {
      let thumbnail = thumbnails[splide.index];
      if (thumbnail) {
        if (current) {
          current.classList.remove("is-active");
        }
        thumbnail.classList.add("is-active");
        current = thumbnail;
      }
    });
    splide.mount();
  }
}
customElements.define("publication-slider", PublicationSlider);
// Subscription Selector
class SubscriptionSelector extends HTMLElement {
  constructor() {
    super();
    this.onetime = document.querySelector('[data-product-type="onetime"]');
    this.subscription = document.querySelector(
      '[data-product-type="subscription"]'
    );
    this.isSubscription = false;
    this.bindEvents();
    this.init();
  }
  bindEvents() {
    this.onetime.addEventListener("click", this.selectOneTime.bind(this));
    this.subscription.addEventListener(
      "click",
      this.selectSubscription.bind(this)
    );
  }
  init() {
    if (this.getParameterByName("subscription") !== null) {
      this.selectSubscription();
    } else {
      this.selectOneTime();
    }
  }
  getSubscriptionData() {
    this.subscriptionData =
      this.subscriptionData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.subscriptionData;
  }
  getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  showSubscription() {
    document
      .querySelector('[data-product-type="onetime"]')
      .classList.remove(
        "component--product--subscription-selector__option--active"
      );
    document
      .querySelector('[data-product-type="subscription"]')
      .classList.add(
        "component--product--subscription-selector__option--active"
      );
  }
  hideSubscription() {
    document
      .querySelector('[data-product-type="onetime"]')
      .classList.add(
        "component--product--subscription-selector__option--active"
      );
    document
      .querySelector('[data-product-type="subscription"]')
      .classList.remove(
        "component--product--subscription-selector__option--active"
      );
  }
  selectOneTime() {
    this.isSubscription = false;
    this.hideSubscription();
    this.toggleInfo(false);
    this.removeInput();
  }
  selectSubscription() {
    this.isSubscription = true;
    this.getSubscriptionData();
    this.sellingPlan = this.subscriptionData[0].selling_plans[0].id;
    this.showSubscription();
    this.createInput(this.sellingPlan);
    this.toggleInfo(true);
  }
  createInput(sellingPlanId) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-bar`
    );
    productForms.forEach((productForm) => {
      if (productForm.querySelector('input[name="selling_plan"]')) {
        productForm
          .querySelector('input[name="selling_plan"]')
          .setAttribute("value", sellingPlanId);
      } else {
        let input = document.createElement("input");
        input.type = "hidden";
        input.setAttribute("name", "selling_plan");
        input.setAttribute("value", sellingPlanId);
        productForm.appendChild(input);
      }
    });
  }
  removeInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-bar`
    );
    productForms.forEach((productForm) => {
      const ele = productForm.querySelector('input[name="selling_plan"]');
      if (ele) {
        ele.parentNode.removeChild(ele);
      }
    });
  }
  toggleInfo(check = false) {
    const info = document.querySelector(
      ".component--product--subscription-selector__info"
    );
    if (check) {
      info.classList.add(
        "component--product--subscription-selector__info--active"
      );
    } else {
      info.classList.remove(
        "component--product--subscription-selector__info--active"
      );
    }
  }
}
customElements.define("subscription-selector", SubscriptionSelector);
class ProductUpsell extends HTMLElement {
  constructor() {
    super();
    this.lineItems = [];
    this.upsells = document.querySelectorAll(".component--product--upsell");
    this.selectedValue = document.querySelector(
      ".component--product--upsell__select-value"
    );
    this.onClick.bind(this);
    this.bindEvents();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.handleClickOutside);
  }
  bindEvents() {
    this.upsells.forEach((upsell) => {
      upsell
        .querySelector(".component--product--upsell__image-wrapper")
        .addEventListener("click", this.onClick.bind(this));
    });
    const customSelect = document.querySelector(
      ".component--product--upsell__select"
    );
    const selectBtn = document.querySelector(
      ".component--product--upsell__select-button"
    );
    const selectedValue = document.querySelector(
      ".component--product--upsell__select-value"
    );
    const selectDropdown = document.querySelector(
      ".component--product--upsell__select-dropdown"
    );
    // add click event to select button
    selectBtn.addEventListener("click", () => {
      // add/remove active class on the container element
      customSelect.classList.toggle(
        "component--product--upsell__select--active"
      );
      selectDropdown.classList.toggle(
        "component--product--upsell__select-dropdown--active"
      );
      // update the aria-expanded attribute based on the current state
      selectBtn.setAttribute(
        "aria-expanded",
        selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true"
      );
    });
    selectDropdown.querySelectorAll("input").forEach((option) => {
      option.addEventListener("change", this.onVariantChange.bind(this));
    });
    /*optionsList.forEach((option) => {
      //option.addEventListener("keyup", this.handler.bind(this, option));
      option.addEventListener("click", this.onVariantChange.bind(this));
    });*/
  }
  handleClickOutside(event) {
    const customSelect = document.querySelector(
      ".component--product--upsell__select"
    );
    const selectDropdown = document.querySelector(
      ".component--product--upsell__select-dropdown"
    );
    if (
      !customSelect.contains(event.target) &&
      customSelect.classList.contains(
        "component--product--upsell__select--active"
      )
    ) {
      customSelect.classList.remove(
        "component--product--upsell__select--active"
      );
      selectDropdown.classList.remove(
        "component--product--upsell__select-dropdown--active"
      );
      document
        .querySelector(".component--product--upsell__select-button")
        .setAttribute("aria-expanded", "false");
    }
  }
  handler(e, option) {
    const customSelect = document.querySelector(
      ".component--product--upsell__select"
    );
    const selectedValue = document.querySelector(
      ".component--product--upsell__select-value"
    );
    // Click Events
    if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
      selectedValue.textContent = this.currentVariant.title;
      customSelect.classList.remove(
        "component--product--upsell__select--active"
      );
    }
    // Key Events
    if (e.key === "Enter") {
      selectedValue.textContent = this.currentVariant.title;
      customSelect.classList.remove(
        "component--product--upsell__select--active"
      );
    }
    this.onVariantChange();
  }
  onClick(event) {
    const ele = event.currentTarget;
    const id = this.getAttribute("data-add-on-id");
    const isExist = this.lineItems.filter((item) => id == item.id).length > 0;
    if (!isExist) {
      this.attachProduct(event);
      this.updateCheckbox(true, ele);
    } else {
      this.deattachProduct(event);
      this.updateCheckbox(false, ele);
    }
  }
  updateCheckbox(check) {
    if (check) {
      document
        .querySelector(".component--product--upsell__checkbox")
        .classList.add("component--product--upsell__checkbox--active");
    } else {
      document
        .querySelector(".component--product--upsell__checkbox")
        .classList.remove("component--product--upsell__checkbox--active");
    }
  }
  attachProduct() {
    const id = this.getAttribute("data-add-on-id");
    const qty = this.getAttribute("data-add-on-qty");
    this.lineItems = [
      {
        id: id,
        quantity: qty
      },
    ];
  }
  deattachProduct() {
    const id = this.getAttribute("data-add-on-id");
    this.lineItems = this.lineItems.filter((item) => id != item.id);
  }
  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    //console.log(this.currentVariant, e.currentTarget);
    const customSelect = document.querySelector(
      ".component--product--upsell__select"
    );
    const selectedValue = document.querySelector(
      ".component--product--upsell__select-value"
    );
    selectedValue.textContent = this.currentVariant.title;
    customSelect.classList.remove("component--product--upsell__select--active");
    const currency = document
      .querySelector(".component--product--upsell__prices")
      .getAttribute("data-iso-code");
    var priceDollars = this.currentVariant.price / 100 * parseInt(this.currentVariant.option1.split(' ')[0]) / 1000;
    var formattedPrice = priceDollars
      .toString()
      .replace(/\.00$/, "")
      .replace(/(\.\d*[1-9])0+$/, "$1");
    document.querySelector(
      ".component--product--upsell__price"
    ).textContent = `$${formattedPrice} ${currency}`;
    const comparePrice = e.currentTarget.getAttribute("data-compare-price");
    if (comparePrice != "") {
      var comparePriceDollars = comparePrice / 100;
      var formattedComparePrice = comparePriceDollars
        .toString()
        .replace(/\.00$/, "")
        .replace(/(\.\d*[1-9])0+$/, "$1");
      document.querySelector(
        ".component--product--upsell__compare-price"
      ).textContent = `$${formattedComparePrice}`;
    }
    document
      .querySelector(".component--product--upsell")
      .setAttribute("data-add-on-id", this.currentVariant.id);
    document
      .querySelector(".component--product--upsell")
      .setAttribute("data-add-on-qty", parseInt(this.currentVariant.title.split(' ')[0]) / 1000);
    document
      .querySelector(".component--product--upsell__select-dropdown")
      .classList.remove("component--product--upsell__select-dropdown--active");
    const id = this.getAttribute("data-add-on-id");
    const isExist = this.lineItems.filter((item) => id == item.id).length > 0;
    if (!isExist) {
      this.attachProduct();
      this.updateCheckbox(true);
    } else {
      this.deattachProduct();
      this.updateCheckbox(false);
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("product-upsell", ProductUpsell);
class ProductBulk extends HTMLElement {
  constructor() {
    super();
    this.productForm = document.querySelector("product-form");
    this.bulkForm = document.querySelector("product-bulk-form");
    this.subscriptionSelector = document.querySelector("subscription-selector");
    this.upsell = document.querySelector("product-upsell");
    this.bindEvents();
  }
  bindEvents() {
    //this.addEventListener("click", this.showBulk.bind(this));
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-700354441/wpQ-COis76MYEImf-s0C",
        event_callback: callback,
      });
      return false;
    }
    document.querySelectorAll("[data-bulk-form-button]").forEach((button) => {
      button.addEventListener("click", () => {
        gtag_report_conversion();
        const { toggle } = window.tf.createSlider("PSGGS5LX", {
          transitiveSearchParams: true,
        });
        toggle();
      });
    });
  }
  showBulk() {
    this.productForm.style.display = "none";
    this.subscriptionSelector.style.display = "none";
    if (this.upsell) {
      this.upsell.style.display = "none";
    }
    document.querySelector(
      ".component--product--sticky-bar__buttons"
    ).style.display = "none";
    document.querySelector(
      ".component--product--sticky-bar__bulk-button"
    ).style.display = "inline-block";
    this.bulkForm.style.display = "block";
    this.classList.add("component--product--case-selector__bulk--active");
    document
      .querySelectorAll(".component--product--case-selector__options-box input")
      .forEach((input) => {
        input.checked = false;
      });
  }
}
customElements.define("product-bulk", ProductBulk);
class ProductBulkBox extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }
  bindEvents() {
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-700354441/wpQ-COis76MYEImf-s0C",
        event_callback: callback,
      });
      return false;
    }
    document.querySelectorAll("[data-bulk-box-button]").forEach((button) => {
      button.addEventListener("click", () => {
        gtag_report_conversion();
        const { toggle } = window.tf.createSlider("PSGGS5LX", {
          transitiveSearchParams: true,
        });
        toggle();
      });
    });
  }
}
customElements.define("product-bulk-box", ProductBulkBox);
/*document.addEventListener("DOMContentLoaded", function (event) {
  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != "undefined") {
        window.location = url;
      }
    };
    gtag("event", "conversion", {
      send_to: "AW-700354441/wpQ-COis76MYEImf-s0C",
      event_callback: callback,
    });
    return false;
  }
  const { toggle } = window.tf.createSlider("PSGGS5LX", {
    transitiveSearchParams: true,
  });
  document
    .querySelector(".component--product--bulk__button")
    .addEventListener("click", () => {
      gtag_report_conversion();
      toggle();
    });
});
document.addEventListener("DOMContentLoaded", function (event) {
  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != "undefined") {
        window.location = url;
      }
    };
    gtag("event", "conversion", {
      send_to: "AW-700354441/wpQ-COis76MYEImf-s0C",
      event_callback: callback,
    });
    return false;
  }
  document.querySelectorAll("[data-bulk-form-button]").forEach((button) => {
    console.log(button);
    button.addEventListener("click", () => {
      gtag_report_conversion();
      const { toggle } = window.tf.createSlider("PSGGS5LX", {
        transitiveSearchParams: true,
      });
      toggle();
    });
  });
});*/



class SampleVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer");
    this.subscriptionSelector = document.querySelector("subscription-selector");
    this.productFormBar = document.querySelector("product-form-bar");
    this.addEventListener("change", this.onVariantChange);
    const seeMore = document.querySelector("[data-see-more]");
    if (seeMore) {
      this.seeMore = false;
      seeMore.addEventListener("click", this.toggleBox.bind(this, seeMore));
      this.bindSelector();
    }
  }
  updateSavingPrice() {
    function removeCents(price) {
      price = price.replace("$", "").replace(/,/g, "");
      price = parseFloat(price);
      let roundedPrice = Math.floor(price);
      return `$${roundedPrice.toLocaleString()}`;
    }
    if (document.querySelectorAll("[data-discount-amount]").length > 0) {
      document.querySelectorAll("[data-discount-amount]").forEach((el) => {
        const price = el.getAttribute("data-discount-amount");
        const formattedprice = removeCents(price);
        el.innerHTML = `Save ${formattedprice}`;
      });
    }
  }
  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    const changedOptionName = e.target.getAttribute("data-option-name");
    if (!this.currentVariant) {
      this.options.pop();
      this.currentVariants = this.getVariantData().filter((variant) => {
        return this.options.every((option, index) => {
          return variant.options[index] === option;
        });
      });
      this.currentVariant = this.currentVariants[0];
    }
    if (this.options.length > 1) {
      if (changedOptionName != "case") {
        this.options.pop();
        this.currentVariants = this.getVariantData().filter((variant) => {
          return this.options.every((option, index) => {
            return variant.options[index] === option;
          });
        });
        this.currentVariant = this.currentVariants[0];
      }
    }
    window.location.href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
  }
  toggleBox(seeMore) {
    const box = document.querySelector(
      ".component--product--sample-variant-case-selector__options-box"
    );
    const labels = box.querySelectorAll("label");
    box.classList.toggle(
      "component--product--sample-variant-case-selector__options-box--hidden"
    );
    document
      .querySelector(
        ".component--product--sample-variant-case-selector__see-more"
      )
      .classList.toggle(
        "component--product--sample-variant-case-selector__see-more--active"
      );
    if (
      box.classList.contains(
        "component--product--sample-variant-case-selector__options-box--hidden"
      )
    ) {
      box.style.height =
        labels[0].clientHeight +
        labels[1].clientHeight +
        labels[2].clientHeight +
        labels[3].clientHeight +
        labels[4].clientHeight +
        "px";
      document
        .querySelector(".page--product--product__container")
        .setAttribute("data-see-more-clicked", "false");
    } else {
      box.style.height = box.scrollHeight + "px";
      seeMore.style.display = "none";
      const bulkBorderTop = document.querySelector(
        ".component--product--sample-variant-case-selector__bulk--border-top"
      );
      if (bulkBorderTop) {
        bulkBorderTop.style.opacity = "0.5";
      }
      document
        .querySelector(".page--product--product__container")
        .setAttribute("data-see-more-clicked", "true");
    }
  }
  bindSelector() {
    const box = document.querySelector(
      ".component--product--sample-variant-case-selector__options-box"
    );
    const radios = box.querySelectorAll('input[type="radio"]');
    const seeMore = document.querySelector("[data-see-more]");
    let isChecked = false;
    if (radios.length > 5) {
      for (let i = 5; i < radios.length; i++) {
        if (radios[i].checked) {
          isChecked = true;
          break;
        }
      }
      const isOpen = JSON.parse(
        document
          .querySelector(".page--product--product__container")
          .getAttribute("data-see-more-clicked")
      );
      if (isOpen) {
        box.classList.remove(
          "component--product--sample-variant-case-selector__options-box--hidden"
        );
        box.style.height = "auto";
        seeMore.style.display = "none";
        const bulkBorderTop = document.querySelector(
          ".component--product--sample-variant-case-selector__bulk--border-top"
        );
        if (bulkBorderTop) {
          bulkBorderTop.style.opacity = "0.5";
        }
      } else {
        if (isChecked) {
          document
            .querySelector(".page--product--product__container")
            .setAttribute("data-see-more-clicked", "true");
          box.classList.remove(
            "component--product--sample-variant-case-selector__options-box--hidden"
          );
          box.style.height = "auto";
          seeMore.style.display = "none";
          const bulkBorderTop = document.querySelector(
            ".component--product--sample-variant-case-selector__bulk--border-top"
          );
          if (bulkBorderTop) {
            bulkBorderTop.style.opacity = "0.5";
          }
        } else {
          const labels = box.querySelectorAll("label");
          if (labels.length > 5) {
            box.style.height =
              labels[0].clientHeight +
              labels[1].clientHeight +
              labels[2].clientHeight +
              labels[3].clientHeight +
              labels[4].clientHeight +
              "px";
          }
        }
      }
      this.updateSavingPrice();
      /*if (isChecked) {
        box.classList.remove(
          "component--product--sample-variant-case-selector__options-box--hidden"
        );
        box.style.height = "auto";
        seeMore.style.display = "none";
        document.querySelector(
          ".component--product--sample-variant-case-selector__bulk--border-top"
        ).style.opacity = "0.5";
      } else {
        if (
          box.classList.contains(
            "component--product--sample-variant-case-selector__options-box--hidden"
          )
        ) {
          const labels = box.querySelectorAll("label");
          if (labels.length > 5) {
            box.style.height =
              labels[0].clientHeight +
              labels[1].clientHeight +
              labels[2].clientHeight +
              labels[3].clientHeight +
              labels[4].clientHeight +
              "px";
            seeMore.querySelector(
              ".component--product--sample-variant-case-selector__see-more-title"
            ).textContent = "See more quantities";
          }
        } else {
          box.style.height = box.scrollHeight + "px";
          seeMore.querySelector(
            ".component--product--sample-variant-case-selector__see-more-title"
          ).textContent = "See less quantities";
          seeMore.style.display = "none";
          document.querySelector(
            ".component--product--sample-variant-case-selector__bulk--border-top"
          ).style.opacity = "0.5";
        }
      }*/
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateMediaByVariant() {
    const variantMedia = document.querySelectorAll("[data-variants]");
    variantMedia.forEach((item) => {
      const value = item.getAttribute("data-variants");
      this.currentVariant.options.forEach((i) => {
        if (i == value) {
          item.classList.add("component--product--media__grid-item--active");
        } else {
          if (value != "") {
            item.classList.remove(
              "component--product--media__grid-item--active"
            );
          } else {
            item.classList.add("component--product--media__grid-item--active");
          }
        }
      });
    });
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }
  updateURL() {
    if (!this.currentVariant) return;
    function getUrlParameter(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    const queryDiscountCode = getUrlParameter("discount");
    if (queryDiscountCode) {
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}&discount=${queryDiscountCode}`
      );
    } else {
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const mediaSource = html.getElementById(
          "page--product--product__content"
        );
        const mediaD = document.getElementById(
          "page--product--product__content"
        );
        mediaD.innerHTML = mediaSource.innerHTML;
        const productStickyBar = document.querySelector("product-sticky-bar");
        if (productStickyBar) productStickyBar.toggle();
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      //const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute("disabled", true);
        if (text) addButton.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        let price;
        if (document.querySelector("[data-product-discount-price]")) {
          if (this.cart.cartDiscountCode) {
            price = document
              .querySelector("[data-product-discount-price]")
              .getAttribute("data-product-discount-price");
          } else if (
            this.cart.cookieDiscountCode === this.cart.cartDiscountCode ||
            this.cart.queryDiscountCode === this.cart.cartDiscountCode
          ) {
            price = document
              .querySelector("[data-product-discount-price]")
              .getAttribute("data-product-discount-price");
          }
        } else {
          price = this.currentVariant.price;
        }
        //console.log('fire', price)
        this.upsell = document.querySelector("product-upsell");
        if (document.querySelector("product-upsell")) {
          const upsellTotal = document
            .querySelector("[data-upsell-total]")
            .getAttribute("data-upsell-total");
          const productPriceElements = document.querySelectorAll(
            "[data-product-form-price]"
          );
          productPriceElements.forEach((productPriceElement) => {
            productPriceElement.setAttribute("data-product-form-price", price);
          });
          const total = JSON.parse(price) + JSON.parse(upsellTotal);
          addButton.textContent =
            window.variantStrings.addToCart + " — " + formatMoney(total);
        } else {
          addButton.textContent =
            window.variantStrings.addToCart + " — " + formatMoney(price);
        }
      }
      if (!modifyClass) return;
    });
  }
  setUnavailable() {
    //const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.unavailable;
      document
        .getElementById(`price-${this.dataset.section}`)
        ?.classList.add("visibility-hidden");
    });
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("sample-variant-selector", SampleVariantSelector);
function initializeQuantitySelectors() {
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  const main_price = document.querySelector('.component--product--price__sale');
  const main_price_full = document.querySelector('.component--product--price__base');
  const main_price_discount = document.querySelector('.component--product--price__discount');
  const main_total_pieces = document.querySelector('.componnent_per_piece_price_total-pieces');
  const main_per_piece = document.querySelector('.componnent_per_piece_price_sigle-piece-price');
  const sticky_pieces = document.querySelector('.bottom_sticky_bar_pcs');
  const bulk_buy_component = document.querySelector('.component--product--case-selector__bulk');
  quantitySelectors.forEach((selector) => {
    let quantity_cases_label = selector.querySelector('.quantity_cases_label');
    let quantity_original_price = selector.querySelector('.quantity_original_price');
    let quantity_compare_price = selector.querySelector('.quantity_compare_price');
    const org_per_pice = parseFloat(quantity_original_price.getAttribute('data-price'));
    const decreaseBtn = selector.querySelector('.quantity-decrease');
    const increaseBtn = selector.querySelector('.quantity-increase');
    const input = selector.querySelector('.quantity-input');
    const pieces_selector = selector.querySelector('.quantity_span_total_pieces');
    const pieces_quantity = parseInt(pieces_selector.getAttribute('data-pieces'));
    const per_piece_selector = selector.querySelector('.quantity_span_per_piece');
    const per_piece_selector_type = per_piece_selector.getAttribute('data-type');
    const quantity_savings = selector.querySelector('.quantity_savings');
    const countryInputs = document.getElementsByName('country_code');
    let countryCode = '';
    if (countryInputs.length > 0) {
      if(countryInputs[0].value == 'US'){
        countryCode = 'USD';
      }
      else if(countryInputs[0].value == 'CA'){
        countryCode = 'CAD';
      }else{
        countryCode = '';
      }
      console.log('countryCode',countryCode);
    }
    
    if (!decreaseBtn || !increaseBtn || !input) return;

    const updateQuantity = (change) => {
      const currentValue = parseInt(input.value, 10) || 0;
      const min = parseInt(input.min, 10) || 0;
      const max = parseInt(input.max, 10) || Infinity;
      const newValue = Math.max(min, Math.min(max, currentValue + change));
      const qunatity_base_price = (newValue*org_per_pice).toFixed(2);
      const total_pieces_quantity = newValue*pieces_quantity;
      let discountPercentage = 0;
      if (newValue >= 3 && newValue <= 5) {
        discountPercentage = 5;
      } else if (newValue >= 6 && newValue <= 8) {
        discountPercentage = 7;
      } else if (newValue === 9) {
        discountPercentage = 9;
      } else if (newValue >= 10) {
        discountPercentage = 10;
      }
      if (newValue > 9) {
      bulk_buy_component.classList.remove("component--product--case-selector__bulk_hide");
      } else{
        bulk_buy_component.classList.add("component--product--case-selector__bulk_hide");
      }
      const discountAmount = (qunatity_base_price * discountPercentage) / 100;
      const discountedPrice = (qunatity_base_price - discountAmount).toFixed(2);
      const per_piece_price = (Math.floor((discountedPrice / total_pieces_quantity) * 1000) / 1000).toFixed(3);
      input.value = newValue;
      const quantityInputForm = document.querySelector('.component--product--form__wrapper input[name="quantity"]');
      if (quantityInputForm) {
        quantityInputForm.value = newValue;
      }else{
        console.log('quantity not found');
      }
      if(newValue < 2){
        quantity_cases_label.textContent= newValue+' Case';
      } else{
        quantity_cases_label.textContent= newValue+' Cases';
      }
      const basePriceParsed = parseFloat(qunatity_base_price);
      const discountedPriceParsed = parseFloat(discountedPrice);
      if ((basePriceParsed * 100) > (discountedPriceParsed * 100)) {
      quantity_compare_price.textContent= '$'+Math.round(qunatity_base_price);
        main_price_full.textContent= '$'+Math.round(qunatity_base_price);
        quantity_savings.textContent='Save $'+Math.round(discountAmount)+' ('+discountPercentage+'%)';
        main_price_discount.textContent='Save $'+Math.round(discountAmount)+' ('+discountPercentage+'%)';
        console.log('qunatity_base_price: ',qunatity_base_price+' - discountedPrice: ',discountedPrice,' discount_true');
      }else{
        quantity_compare_price.textContent='';
        main_price_full.textContent= '';
        quantity_savings.textContent='';
        main_price_discount.textContent='';
        console.log('qunatity_base_price: ',qunatity_base_price+' - discountedPrice: ',discountedPrice, 'discount_false');
      }
      quantity_original_price.textContent= '$'+discountedPrice+' '+countryCode;
      main_price.textContent = '$'+discountedPrice+' '+countryCode;
      pieces_selector.textContent= total_pieces_quantity.toLocaleString('en-US')+' PCS';
      main_total_pieces.textContent= total_pieces_quantity.toLocaleString('en-US')+' PCS';
      sticky_pieces.textContent= total_pieces_quantity.toLocaleString('en-US')+' PCS';
      per_piece_selector.textContent= ' / '+per_piece_price+' per '+per_piece_selector_type;
      main_per_piece.textContent= per_piece_price+'/'+per_piece_selector_type;
      toggleButtonState();
    };

    const toggleButtonState = () => {
      const currentValue = parseInt(input.value, 10) || 0;
      decreaseBtn.disabled = currentValue <= (parseInt(input.min, 10) || 0);
      increaseBtn.disabled = currentValue >= (parseInt(input.max, 10) || Infinity);
    };

    decreaseBtn.addEventListener('click', () => updateQuantity(-1));
    increaseBtn.addEventListener('click', () => updateQuantity(1));
    input.addEventListener('input', () => {
      const value = Math.max(input.min || 0, Math.min(input.max || Infinity, parseInt(input.value, 10) || 0));
      input.value = value;
      toggleButtonState();
    });
    toggleButtonState();
  });
}
function initPopupScripts() {
  const popup = document.getElementById("mcmsSaveMorePopup");
  const overlay = document.querySelector(".mcms-popup-overlay");
  const screen_lock = document.querySelector("body");
  const openPopupBtn = document.getElementById("mcmsOpenPopup");
  const closePopupBtn = popup.querySelector(".mcms-popup-close");

  function openPopup() {
    if (window.innerWidth > 768) {
      popup.classList.add("mcms-fade-in");
    } else {
      popup.classList.add("mcms-slide-up");
    }
    screen_lock.classList.add("locked_scroll");
    popup.classList.remove("mcms-hidden");
    overlay.classList.add("mcms-visible");
  }

  function closePopup() {
    if (window.innerWidth > 768) {
      popup.classList.add("mcms-hidden");
      popup.classList.remove("mcms-fade-in");
    } else {
      popup.classList.add("mcms-slide-down");
      setTimeout(() => {
        popup.classList.add("mcms-hidden");
        popup.classList.remove("mcms-slide-up", "mcms-slide-down");
      }, 300);
    }
    screen_lock.classList.remove("locked_scroll");
    overlay.classList.remove("mcms-visible");
  }

  openPopupBtn.addEventListener("click", openPopup);
  closePopupBtn.addEventListener("click", closePopup);
  overlay.addEventListener("click", closePopup);
}
function reinitializeAfterVariantChange() {
  const variantInputs = document.querySelectorAll('.component--product--variant-radio__input');

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      console.log('Variant changed');
      setTimeout(() => {
        initializeQuantitySelectors();
        initPopupScripts();
        reinitializeAfterVariantChange();
        console.log('Quantity selectors reinitialized after variant change');
      }, 1500);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeQuantitySelectors();
  initPopupScripts();
  reinitializeAfterVariantChange();
});